<template>
  <v-tooltip :disabled="!value.name"
             top>
    <template #activator="{ on, attrs }">
      <span v-bind="attrs"
            class="mx-2"
            v-on="on">
        <flag :iso="value.id || value.alpha2Code || value" :squared="false"/>
      </span>
    </template>
    <span>{{ value.name }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CountryFlagCell",
  props: {
    value: {}
  },
}
</script>

<style scoped>

</style>
